import { defineStyleConfig } from '@chakra-ui/react';

const Progress = defineStyleConfig({
  baseStyle: (props) => ({
    filledTrack: {
      bg: props.colorScheme === 'brand' ? 'brand.blue.500' : `${props.colorScheme}.500`,
    },
    track: {
        bg: props.colorMode === 'dark' ? 'gray.700' : 'gray.200',
    }
  }),
});

export default Progress;
